import { RECORD_DATA_MANAGER } from "../../data";

export default {
    namespaced: true,
    state: {
        showAllRecord: false,
        filterListData: [],
        curFilterData: {title: 'all', text: '全部记录'}
    },
    mutations: {},
    actions: {
        filterAllRecordList({ dispatch, state }) {
            var groupId = 0, title = state.curFilterData.title,
                recordTotalData = AppFate.$store.state.record.recordTotalData;
    
            // 处理分组id
            if(title != 'ungroup'){
                if(title.indexOf('group') != -1){
                    groupId = parseInt(title.slice(5))
                    title = 'group';
                }
            }
            console.log('filterAllRecordList-----', title, recordTotalData);
            switch(title) {
                case 'all':
                    state.filterListData = RECORD_DATA_MANAGER.getResultListSort(recordTotalData);
                    break;
                case 'ungroup':
                case 'group':
                    state.filterListData = RECORD_DATA_MANAGER.getFilterRecordData(recordTotalData, 'groupId', groupId);
                    break;
                case 'pipan':
                case 'nunpan':
                    state.filterListData = RECORD_DATA_MANAGER.getFilterRecordData(recordTotalData, title, 1);
                    break;
                case 'hb':
                    state.filterListData = recordTotalData.filter(data => data['hb'] != 0)
                    break;
                default:
                    break;
            }

            // 处理过滤数据
            dispatch('record/setRecordList', state.filterListData, {root: true});

            // 处理字母开头相关数据
            var letterList = RECORD_DATA_MANAGER.getRecordLetterListData(state.filterListData);
            dispatch('recordletter/setRecordLetterList', letterList, {root: true});
        },
        resetRecordData({ dispatch, state }) {
            state.showAllRecord = false;
            state.curFilterData = {title: 'all', text: '全部记录'};
            dispatch('filterAllRecordList');
        }
    }
}